// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__vD5zV","header":"styles_header__PdEjH","projectedText":"styles_projectedText__-0w5o"};